/**
 * Presell buy box v12.9 — the "VIEW DETAILS" sheet (sections/afroyla-seen-buy.liquid).
 *
 * Owner 06.09.2026 13:34: "mỗi lần click xong phải scroll lên gallery cũng
 * phiền … ấn vào thì popup ra chi tiết sản phẩm … có copywriting sâu để thuyết
 * phục". Every picker row (backpack slots and free-gift rows) ends with a
 * [data-buy-view] link painted by assets/afroyla-seen-buy.js; this file opens
 * a sheet for the row's CURRENT pick:
 *   photos (hero + one row of four thumbs) · eyebrow · name · name meaning ·
 *   founder note · why-her list · details list · one verified review · the
 *   row's ship line · a "Back to your set" button that just closes (owner 06.09: "Chosen — …" said nothing about what the tap does).
 *
 * Data comes from the DOM the section already renders — nothing is fetched:
 *   backpack  → [data-buy-design][data-name]: photos from its gallery thumbs,
 *               data-meaning / data-note / data-facts
 *   gift      → [data-gift-pool="t"] [data-gift-option][index]: data-images /
 *               data-thumbs / data-name / data-note / data-facts
 *   strings   → the section's <script type="application/json" data-sheet-copy>
 * Styles: assets/afroyla-seen-detail-sheet.css.
 */
(function () {
  'use strict';

  if (window.__aflSeenSheetInit) return;
  window.__aflSeenSheetInit = true;

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function fill(template, tokens) {
    var out = template || '';
    Object.keys(tokens).forEach(function (key) {
      out = out.split('{' + key + '}').join(tokens[key]);
    });
    return out;
  }

  function copyFor(root) {
    var el = root.querySelector('[data-sheet-copy]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent) || {};
    } catch (e) {
      return {};
    }
  }

  function list(values) {
    return values.filter(function (v) {
      return v && String(v).trim();
    });
  }

  /* ---- what a row is showing --------------------------------------------- */
  function designInfo(root, copy, name) {
    var d = root.querySelector('[data-buy-design][data-name="' + name.replace(/"/g, '\\"') + '"]');
    if (!d) return null;
    var photos = Array.prototype.slice.call(d.querySelectorAll('[data-buy-thumb]')).map(function (t) {
      var img = t.querySelector('img');
      return { big: t.getAttribute('data-main-src') || '', thumb: img ? img.getAttribute('src') || '' : '' };
    });
    return {
      eyebrow: copy.eyebrow || '',
      name: name,
      meaning: d.getAttribute('data-meaning') || '',
      note: d.getAttribute('data-note') || '',
      photos: photos,
      whyLabel: copy.whyLabel || '',
      why: list(copy.why || []),
      details: list([d.getAttribute('data-facts'), copy.material, copy.ship]),
      proof: true,
    };
  }

  function giftInfo(root, copy, tier, index) {
    var pool = root.querySelector('[data-gift-pool="' + (tier + 1) + '"]');
    if (!pool) return null;
    var option = pool.querySelectorAll('[data-gift-option]')[index];
    if (!option) return null;
    var bigs = (option.getAttribute('data-images') || '').split('|').filter(Boolean);
    var thumbs = (option.getAttribute('data-thumbs') || '').split('|').filter(Boolean);
    if (!bigs.length) {
      var src = option.getAttribute('data-src') || '';
      bigs = [src.replace(/width=\d+/, 'width=900')];
      thumbs = [src.replace(/width=\d+/, 'width=400')];
    }
    var kind = pool.getAttribute('data-gift-name') || '';
    return {
      eyebrow: fill(copy.giftEyebrow || 'Free {kind}', { kind: kind }),
      name: (option.getAttribute('data-name') || '').replace(/ /g, ' ').trim(),
      meaning: '',
      note: option.getAttribute('data-note') || '',
      photos: bigs.map(function (b, i) {
        return { big: b, thumb: thumbs[i] || b };
      }),
      whyLabel: copy.giftWhyLabel || '',
      why: list(copy.giftWhy || []),
      details: list([option.getAttribute('data-facts'), copy.material]),
      proof: false,
    };
  }

  /* ---- the sheet ----------------------------------------------------------- */
  var overlay = null;
  var sheet = null;
  var lastFocus = null;

  function closeSheet() {
    if (!sheet) return;
    var s = sheet;
    var o = overlay;
    sheet = overlay = null;
    s.classList.remove('is-open');
    o.classList.remove('is-open');
    document.documentElement.classList.remove('afl-sheet-lock');
    window.setTimeout(function () {
      s.remove();
      o.remove();
    }, 280);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function openSheet(info, copy, shipHtml) {
    closeSheet();
    var first = info.photos[0] || { big: '', thumb: '' };
    overlay = document.createElement('div');
    overlay.className = 'afl-sheet-overlay';
    sheet = document.createElement('div');
    sheet.className = 'afl-sheet';
    sheet.setAttribute('data-hc-section', 'modal'); // HC Pixel role: clicks inside report as modal
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', info.name);

    var thumbs = info.photos
      .map(function (p, i) {
        return (
          '<button type="button" class="afl-sheet__thumb" data-hc-el="gallery-thumb" data-big="' +
          esc(p.big) +
          '" aria-current="' +
          (i === 0 ? 'true' : 'false') +
          '"><img src="' +
          esc(p.thumb) +
          '" alt="" loading="lazy" decoding="async"></button>'
        );
      })
      .join('');
    var li = function (items) {
      return items
        .map(function (t) {
          return '<li>' + esc(t) + '</li>';
        })
        .join('');
    };

    sheet.innerHTML =
      '<button type="button" class="afl-sheet__close" aria-label="Close" data-hc-el="x-sheet-close">×</button>' +
      '<div class="afl-sheet__media"><img class="afl-sheet__hero" src="' +
      esc(first.big) +
      '" alt="' +
      esc(info.name) +
      '">' +
      (info.photos.length > 1 ? '<div class="afl-sheet__thumbs">' + thumbs + '</div>' : '') +
      '</div>' +
      '<div class="afl-sheet__body">' +
      (info.eyebrow ? '<span class="afl-sheet__eyebrow">' + esc(info.eyebrow) + '</span>' : '') +
      '<h3 class="afl-sheet__title">' +
      esc(info.name) +
      '</h3>' +
      (info.meaning ? '<p class="afl-sheet__meaning">' + esc(info.meaning) + '</p>' : '') +
      (info.note ? '<p class="afl-sheet__note">' + esc(info.note) + '</p>' : '') +
      (info.why.length ? '<span class="afl-sheet__h">' + esc(info.whyLabel) + '</span><ul class="afl-sheet__list">' + li(info.why) + '</ul>' : '') +
      (info.details.length ? '<span class="afl-sheet__h">' + esc(copy.detailsLabel || 'The details') + '</span><ul class="afl-sheet__list">' + li(info.details) + '</ul>' : '') +
      (info.proof && copy.quote
        ? '<figure class="afl-sheet__proof"><span class="afl-sheet__eyebrow">' + esc(copy.proofTag || 'Verified review') + '</span><blockquote>' + esc(copy.quote) + '</blockquote><figcaption>' + esc(copy.quoteBy || '') + '</figcaption></figure>'
        : '') +
      (shipHtml ? '<p class="afl-sheet__ship">' + shipHtml + '</p>' : '') +
      '<button type="button" class="afl-sheet__btn" data-hc-el="x-sheet-close">' +
      esc(fill(copy.chosen || 'Back to your set', { name: info.name })) +
      '</button></div>';

    document.body.appendChild(overlay);
    document.body.appendChild(sheet);
    document.documentElement.classList.add('afl-sheet-lock');
    overlay.addEventListener('click', closeSheet);
    sheet.querySelector('.afl-sheet__close').addEventListener('click', closeSheet);
    sheet.querySelector('.afl-sheet__btn').addEventListener('click', closeSheet);
    sheet.addEventListener('click', function (event) {
      var thumb = event.target.closest('.afl-sheet__thumb');
      if (!thumb || !sheet) return;
      sheet.querySelector('.afl-sheet__hero').src = thumb.getAttribute('data-big');
      sheet.querySelectorAll('.afl-sheet__thumb').forEach(function (other) {
        other.setAttribute('aria-current', other === thumb ? 'true' : 'false');
      });
    });
    window.requestAnimationFrame(function () {
      if (!sheet) return;
      overlay.classList.add('is-open');
      sheet.classList.add('is-open');
      sheet.querySelector('.afl-sheet__close').focus();
    });
  }

  function openForRow(row) {
    var root = row.closest('[data-afl-buy]');
    var on = row.querySelector('.afl-buy__th.is-on');
    if (!root || !on) return;
    var copy = copyFor(root);
    var info = on.hasAttribute('data-gift-tier')
      ? giftInfo(root, copy, parseInt(on.getAttribute('data-gift-tier'), 10) || 0, parseInt(on.getAttribute('data-gift-index'), 10) || 0)
      : designInfo(root, copy, (on.querySelector('.afl-buy__th-n') || {}).textContent || '');
    if (!info) return;
    var line = row.querySelector('.afl-buy__pick-ship, .afl-buy__gift-line, .afl-buy__chosen-ship'); // folded rows carry the status in the chosen line
    openSheet(info, copy, line ? line.innerHTML : '');
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var view = event.target.closest('[data-buy-view]');
    if (!view) return;
    event.preventDefault();
    event.stopPropagation();
    var row = view.closest('.afl-buy__pick, .afl-buy__gift-row');
    if (!row) return;
    lastFocus = view;
    openForRow(row);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && sheet) closeSheet();
  });
})();
